/**
 * Get icon classes from an icon string. If 'icon' is a string without spaces, this function will return by default solid icon class (e.g. 'fas {icon}').
 * If 'icon' is a string with spaces, it will split it and return '{icon[0]} {icon[1]}'.
 * In order to provide regular icon a string with spaces should be used (e.g. 'far envelop').
 * If a brand icon is used (e.g. 'facebook') brand prefix 'fab' will be added.
 * If the specific icon is not prefixed with 'fa-', it will be added.
 *
 * @param {string} icon
 * @returns {string} icon class with the appropriate variant, if provided
 */
export default function getIconClasses(icon) {
    const parts = icon.split(' ');
    if (parts.length === 1) {
        parts[1] = parts[0];
        parts[0] = getPrefix(parts[1]);
    }
    if (!hasIconPrefix(parts[1])) {
        parts[1] = `${fontAwesomeIconPrefix}${parts[1]}`;
    }
    return parts.join(' ');
}

function getPrefix(icon) {
    if (hasIconPrefix(icon)) {
        icon = icon.slice(fontAwesomeIconPrefix.length);
    }
    return brandIcons.has(icon) ? fontAwesomeBrandPrefix : defaultFontAwesomePrefix;
}

function hasIconPrefix(icon) {
    return icon.startsWith(fontAwesomeIconPrefix);
}

// For brand icons fab prefix is used
const brandIcons = new Set(['500px', 'adn', 'amazon', 'android', 'angellist', 'apple', 'bandcamp', 'behance',
    'behance-square', 'bitbucket', 'bitbucket-square', 'bitcoin', 'black-tie', 'bluetooth', 'bluetooth-b',
    'btc', 'buysellads', 'cc-amex', 'cc-diners-club', 'cc-discover', 'cc-jcb', 'cc-mastercard', 'cc-paypal',
    'cc-stripe', 'cc-visa', 'chrome', 'codepen', 'codiepie', 'connectdevelop', 'contao', 'css3', 'dashcube',
    'delicious', 'deviantart', 'digg', 'dribbble', 'dropbox', 'drupal', 'edge', 'eercast', 'empire', 'envira',
    'etsy', 'expeditedssl', 'fa', 'facebook', 'facebook-f', 'facebook-official', 'facebook-square', 'firefox',
    'first-order', 'flickr', 'font-awesome', 'fonticons', 'fort-awesome', 'forumbee', 'foursquare',
    'free-code-camp', 'ge', 'get-pocket', 'gg', 'gg-circle', 'git', 'git-square', 'github', 'github-alt',
    'github-square', 'gitlab', 'gittip', 'glide', 'glide-g', 'google', 'google-plus', 'google-plus-circle',
    'google-plus-official', 'google-plus-square', 'google-wallet', 'gratipay', 'grav', 'hacker-news', 'houzz',
    'html5', 'imdb', 'instagram', 'internet-explorer', 'ioxhost', 'joomla', 'jsfiddle', 'lastfm', 'lastfm-square',
    'leanpub', 'linkedin', 'linkedin-square', 'linode', 'linux', 'maxcdn', 'meanpath', 'medium', 'meetup',
    'mixcloud', 'modx', 'odnoklassniki', 'odnoklassniki-square', 'opencart', 'openid', 'opera', 'optin-monster',
    'pagelines', 'paypal', 'pied-piper', 'pied-piper-alt', 'pied-piper-pp', 'pinterest', 'pinterest-p',
    'pinterest-square', 'product-hunt', 'qq', 'quora', 'ra', 'ravelry', 'rebel', 'reddit', 'reddit-alien',
    'reddit-square', 'renren', 'resistance', 'safari', 'scribd', 'sellsy', 'share-alt', 'share-alt-square',
    'shirtsinbulk', 'simplybuilt', 'skyatlas', 'skype', 'slack', 'slideshare', 'snapchat', 'snapchat-ghost',
    'snapchat-square', 'soundcloud', 'spotify', 'stack-exchange', 'stack-overflow', 'steam', 'steam-square',
    'stumbleupon', 'stumbleupon-circle', 'superpowers', 'telegram', 'tencent-weibo', 'themeisle', 'trello',
    'tripadvisor', 'tumblr', 'tumblr-square', 'twitch', 'twitter', 'twitter-square', 'usb', 'viacoin',
    'viadeo', 'viadeo-square', 'vimeo', 'vimeo-square', 'vine', 'vk', 'wechat', 'weibo', 'weixin', 'whatsapp',
    'wikipedia-w', 'windows', 'wordpress', 'wpbeginner', 'wpexplorer', 'wpforms', 'xing', 'xing-square',
    'y-combinator', 'y-combinator-square', 'yahoo', 'yc', 'yc-square', 'yelp', 'yoast', 'youtube', 'youtube-play',
    'youtube-square']);

const defaultFontAwesomePrefix = 'fas';
const fontAwesomeBrandPrefix = 'fab';
const fontAwesomeIconPrefix = 'fa-';
